export default __webpack_public_path__ + "static/media/Small.4c258d91.png";